/**
 * Surviving selectors of the retired structures list: the selected plant (site
 * group) id, the resolved plant record, and the sites belonging to it. Consumed
 * by the left nav, breadcrumbs, site-dashboard chrome, and the clone-unit modal.
 * Return the Immutable shape their consumers still expect.
 */
// eslint-disable-next-line no-restricted-imports -- approved output-boundary shim for billboard consumers
import { List, Map } from 'immutable';
import { createSelector } from 'reselect';

import { siteSelector } from '@sophocles/entities/Site';
import { getSiteGroupsWithWeatherConfiguration } from '@sophocles/entities/SiteGroup';

export const selectedPlant = state => state.selectedPlant.selectedPlant;

export const getSelectedPlantSelector = createSelector(
  selectedPlant,
  getSiteGroupsWithWeatherConfiguration,
  (selected, plants) => plants.get(selected.toString(), Map()),
);

export const getStructuresForPlant = createSelector(siteSelector, selectedPlant, (structures, plant) => {
  const newStructs = structures.filter(structure => List(structure.get('site_groups', [])).includes(parseInt(plant)));
  return newStructs.map(x => Map(x));
});
